import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { ErrorMessage } from '../../../../extras/toastMessages';
import clienteAxios from '../../../../../config/axios';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner'
import { FUNC_FISCAL } from '../../../../../data/functionaryTypes';
import { FISCALIA } from '../../../../../data/jurisdictions';
//Redux
import { useDispatch } from 'react-redux';
import { updateOfijuAction } from '../../../../../actions/audiencesActions';
import { MSG_ERROR_SERVER } from '../../../../../constants/messages';
const OfijuForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los ref
    const refOfiju = useRef();
    //Inicializo datos
    const initialData = {
        ofiju: audience && audience.ofiju ? audience.ofiju.id : ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [ofijus, setOfijus] = useState([]);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los motivos
        loadParameters();
        //Pongo el foco en el primer campo
        refOfiju.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            ofijuId: values.ofiju
        }
        //Llamo al dispatch
        dispatch( updateOfijuAction(audience, data, handleClose) );
    }
    //Función que cargar los parámetros
    const loadParameters = async () => {
        try{
            //Ofiju
            const responseOfijus = await clienteAxios.get(`/ofiju?search=activo:1&sort=nombre:asc`);
            setOfijus(responseOfijus.data.content);

        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Esquema de validación
    const validationSchema = yup.object({
        ofiju: yup.number().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Ofiju <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione la Ofiju que desea asignar.
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        id="ofiju"
                                        className="form-control"  
                                        name="ofiju"  
                                        value={ values.ofiju }
                                        onChange={handleChange}
                                        ref={refOfiju}
                                        isInvalid={!!errors.ofiju}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione Ofiju...</option>
                                        {
                                            ofijus.map(o => (
                                                <option value={ o.id } key={`oefo${o.id}`}>
                                                    { o.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ofiju }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default OfijuForm;